const menu = function(selector=".menu"){
	const menuWrapper = document.querySelector(`${selector}__wrapper`);
	const menuToggler = document.querySelector(`${selector}__toggler`);
	const toggle = () => {
		menuWrapper.classList.toggle('menu__wrapper--opened');
	}
	menuToggler.addEventListener('click', toggle);
};

export default menu;